import { render, staticRenderFns } from "./BookDetails.vue?vue&type=template&id=4d7ff89e&scoped=true"
import script from "./BookDetails.vue?vue&type=script&lang=js"
export * from "./BookDetails.vue?vue&type=script&lang=js"
import style0 from "./BookDetails.vue?vue&type=style&index=0&id=4d7ff89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7ff89e",
  null
  
)

export default component.exports